import { render, staticRenderFns } from "./CustomerRegistration.vue?vue&type=template&id=3c4c92f5&"
import script from "./CustomerRegistration.vue?vue&type=script&lang=js&"
export * from "./CustomerRegistration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c4c92f5')) {
      api.createRecord('3c4c92f5', component.options)
    } else {
      api.reload('3c4c92f5', component.options)
    }
    module.hot.accept("./CustomerRegistration.vue?vue&type=template&id=3c4c92f5&", function () {
      api.rerender('3c4c92f5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/customers/CustomerRegistration.vue"
export default component.exports